/* tslint:disable */
/* eslint-disable */
/**
 * Kinde Management API
 * Provides endpoints to manage your Kinde Businesses
 *
 * The version of the OpenAPI document: 1
 * Contact: support@kinde.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime.js';
import { UserIdentitiesInnerFromJSON, UserIdentitiesInnerToJSON, } from './UserIdentitiesInner.js';
/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value) {
    var isInstance = true;
    return isInstance;
}
export function UserFromJSON(json) {
    return UserFromJSONTyped(json, false);
}
export function UserFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'providedId': !exists(json, 'provided_id') ? undefined : json['provided_id'],
        'preferredEmail': !exists(json, 'preferred_email') ? undefined : json['preferred_email'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'lastName': !exists(json, 'last_name') ? undefined : json['last_name'],
        'firstName': !exists(json, 'first_name') ? undefined : json['first_name'],
        'isSuspended': !exists(json, 'is_suspended') ? undefined : json['is_suspended'],
        'picture': !exists(json, 'picture') ? undefined : json['picture'],
        'totalSignIns': !exists(json, 'total_sign_ins') ? undefined : json['total_sign_ins'],
        'failedSignIns': !exists(json, 'failed_sign_ins') ? undefined : json['failed_sign_ins'],
        'lastSignedIn': !exists(json, 'last_signed_in') ? undefined : json['last_signed_in'],
        'createdOn': !exists(json, 'created_on') ? undefined : json['created_on'],
        'organizations': !exists(json, 'organizations') ? undefined : json['organizations'],
        'identities': !exists(json, 'identities') ? undefined : (json['identities'].map(UserIdentitiesInnerFromJSON)),
    };
}
export function UserToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'provided_id': value.providedId,
        'preferred_email': value.preferredEmail,
        'username': value.username,
        'last_name': value.lastName,
        'first_name': value.firstName,
        'is_suspended': value.isSuspended,
        'picture': value.picture,
        'total_sign_ins': value.totalSignIns,
        'failed_sign_ins': value.failedSignIns,
        'last_signed_in': value.lastSignedIn,
        'created_on': value.createdOn,
        'organizations': value.organizations,
        'identities': value.identities === undefined ? undefined : (value.identities.map(UserIdentitiesInnerToJSON)),
    };
}
